<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">Wifi设备</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="AP名称" prop="equipmentName">
            <el-input v-model="equipmentName" placeholder="请输入AP名称"></el-input>
          </el-form-item>
          <el-form-item label="IP地址" prop="equipmentIp">
            <el-input v-model="equipmentIp" placeholder="请输入IP地址"></el-input>
          </el-form-item>
          <el-form-item label="是否在线">
            <el-select v-model="Status" placeholder="请选择">
              <el-option
                v-for="item in StatusArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="区域">
            <treeselect
              v-model="Region"
              :options="regionDataTree"
              noResultsText="暂无选择项"
              placeholder="请选择区域"
            />
          </el-form-item>
          <!-- <el-form-item label="地理位置" prop="Location">
            <el-input
              v-model="Location"
              placeholder="请输入地理位置"
            ></el-input>
          </el-form-item> -->
          <el-row>
            <el-col>
              <el-form-item label class="right">
                <el-button @click="onSearch">查 询</el-button>
                <el-button @click="onCancel">清 理</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar">
          <el-button size="mini" @click="onAdd">添 加</el-button>
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              ref="multipleTable"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column
                type="index"
                label="序号"
                width="80"
                align="center"
              ></el-table-column>
              <el-table-column prop="equipmentName" label="AP名称"></el-table-column>
              <el-table-column prop="equipmentIp" label="IP地址"></el-table-column>
              <!-- <el-table-column
                prop="VisitorCount"
                label="连接人数"
              ></el-table-column> -->
              <el-table-column 
                prop="areaCode" 
                label="区域"
              ></el-table-column>
              <!--  :formatter="RegionNumToNameConverter" -->
              <el-table-column
                prop="equipmentLocation"
                label="地理位置"
                width="140"
              ></el-table-column>

              <el-table-column prop="longitude" label="经度"></el-table-column>
              <el-table-column prop="latitude" label="纬度"></el-table-column>
              <el-table-column prop="onlineStatusTranslated" label="是否在线">
                <!-- <template slot-scope="scope">
                  <span v-if="scope.row.Status == 0" style="color:red;"
                    >离线</span
                  >
                  <span v-else-if="scope.row.Status == 1" style="color:green;"
                    >在线</span
                  >
                </template> -->
              </el-table-column>
              <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <template>
                    <el-button
                      @click="queryDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >查看</el-button
                    >
                    <el-button
                      @click="editDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >编辑</el-button
                    >
                    <el-button
                      @click="deleteClick(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >删除</el-button
                    >
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import MyApis from "../../../apis";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { listEquipmentAreaTree, listEquipmentArea } from "@/api/src/equipmentArea";
import { listEquipment,delEquipment} from "@/api/src/equipment";
export default {
  name: "WifiDeviceManagerView",
  controller: "UI",
  action: "WifiDeviceManagerView",
  components: {
    Treeselect
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      equipmentName: "",
      equipmentIp: "",
      Location: "",
      Status: "",
      StatusArr: [
        { value: "", label: "全部" },
        { value: 1, label: "在线" },
        { value: 2, label: "离线" },
      ],
      Region: null,
      regionDataTree: [],
      regionDataList: [],
    };
  },
  created: function() {
    this.getAreaTree();
    this.getAreaList();
  },
  mounted: function() {
    this.search();
  },
  methods: {
    // 查询区域-树
    getAreaTree(){
      listEquipmentAreaTree().then(response => {
        // 修改tree字段
        const mapTree = obj => {
          const haveChildren = Array.isArray(obj.children) && obj.children.length > 0;
          return{
            id: obj.code,
            label: obj.label,
            children: haveChildren ? obj.children.map(i => mapTree(i)) : undefined
          }
        }
        this.regionDataTree = response.data.map(obj => mapTree(obj));
      });
    },
    // 查询区域-列表
    getAreaList(){
      listEquipmentArea().then(response => {
        this.regionDataList = response.rows;
      })
    },
    RegionNumToNameConverter(row) {
      let arr = this.regionDataList.filter(item => {
        return item.areaCode == row.Extend1
      });
      if(arr.length){
        return arr[0].areaName
      }
    },
    search() {
      this.loading = true;
      this.loadingText = "加载中...";
      let searchInfo = {
        equipmentName: this.equipmentName,
        equipmentIp: this.equipmentIp,
        equipmentLocation: this.Location,
        areaCode:this.Region,
        // areaCode:this.areaCode,
        categoryCode: "wifi",
        onlineStatus: this.Status,
        PageSize: this.pageSize,
        pageNum: this.currentPage
      };
      listEquipment(searchInfo).then(res=>{
        this.loading = false;
        if(res.code==200){
          this.tableData = res.rows;
          this.total = res.total;
        }else{
          this.tableData = [];
          this.total = 0;
        }
      })
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/wifi/UI/WifiDeviceManagerEdit",
        query: {
          areaTree: this.regionDataTree,
          type: "add",
        },
      });
    },
    //查看
    queryDetail(index, row) {
      this.$router.push({
        path: "/plugin/wifi/ui/WifiDeviceManagerEdit",
        query: { areaTree: this.regionDataTree, InfoId: row.id, type: "query" },
      });
    },
    //编辑
    editDetail(index, row) {
      this.$router.push({
        path: "/plugin/wifi/ui/WifiDeviceManagerEdit",
        query: { areaTree: this.regionDataTree, InfoId: row.id, type: "edit" },
      });
    },
    //行删除
    deleteClick(index, row) {
      console.log(index)
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delEquipment(row).then(res=>{
            if(res.code==200||res.code==0){
               this.$message({
                  type: "success",
                  message: "删除成功!",
                });
            }else {
                this.$message({
                  type: "error",
                  message: "删除失败!",
                });
            }
             this.search();
          })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 点击查询按钮
    onSearch() {
      if (new Date(this.EndTime) < new Date(this.BeginTime)) {
        this.$message.error("开始时间不能大于结束时间");
        return;
      }
      this.currentPage = 1;
      this.search();
    },
    clearsearch() {
      this.equipmentName = "";
      this.equipmentIp = "";
      this.Location = "";
      this.Status = "";
      this.Region = null;
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    },
  },
};
</script>
<style scoped>
::v-deep .el-form-item{
  vertical-align: middle;
}
::v-deep .vue-treeselect__control{
  width: 178px;
  height: 4rem;
  border-radius: 0px;
}
::v-deep .vue-treeselect__placeholder, 
::v-deep .vue-treeselect__single-value{
  line-height: unset;
}
::v-deep .vue-treeselect__menu{
  border-radius: 0px;
}
</style>